"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Enforces proper shape for theme without throwing away the user specific values
var createTheme = function (themeObject) { return themeObject; };
exports.default = createTheme;
